/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * @format
 */
import PropTypes from 'prop-types';

export default PropTypes.shape({
    alt_permit_holders: PropTypes.arrayOf(PropTypes.object),
    amount_paid: PropTypes.number,
    comment: PropTypes.string,
    commercial_fields: PropTypes.shape({
        client_info: PropTypes.string,
        service_type: PropTypes.string,
    }),
    date_issued: PropTypes.string,
    division_id: PropTypes.string,
    emergency_contact: PropTypes.shape({
        account_id: PropTypes.string,
        attributes: PropTypes.shape({}),
        cell_phone: PropTypes.string,
        email: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string,
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string,
        middle_name: PropTypes.string,
        remark: PropTypes.string,
    }),
    end_date: PropTypes.string,
    entrance: PropTypes.string,
    exit: PropTypes.string,
    extra_fields: PropTypes.shape({
        group_size: PropTypes.number,
        is_modify_quota: false,
        dnr_number: PropTypes.string,
    }),
    fee_override_justification: PropTypes.string,
    fee_overrides: null,
    fulfillment_type: PropTypes.number,
    group_members: PropTypes.arrayOf(
        PropTypes.shape({
            account_id: PropTypes.string,
            attributes: PropTypes.shape({}),
            cell_phone: PropTypes.string,
            email: PropTypes.string,
            first_name: PropTypes.string,
            home_address: PropTypes.shape({
                address1: PropTypes.string,
                address2: PropTypes.string,
                city: PropTypes.string,
                country: PropTypes.string,
                state: PropTypes.string,
                zip_code: PropTypes.string,
            }),
            home_phone: PropTypes.string,
            last_name: PropTypes.string,
            middle_name: PropTypes.string,
            remark: PropTypes.string,
        })
    ),
    id: PropTypes.string,
    issue_station: PropTypes.string,
    lottery_applied: PropTypes.bool,
    modification_count: PropTypes.number,
    need_to_know_checked: PropTypes.bool,
    order_date: PropTypes.string,
    order_id: PropTypes.string,
    permit_holder: PropTypes.shape({
        account_id: PropTypes.string,
        cell_phone: PropTypes.string,
        email: PropTypes.string,
        first_name: PropTypes.string,
        home_address: PropTypes.shape({
            address1: PropTypes.string,
            address2: PropTypes.string,
            city: PropTypes.string,
            country: PropTypes.string,
            state: PropTypes.string,
            zip_code: PropTypes.string,
        }),
        home_phone: PropTypes.string,
        last_name: PropTypes.string,
    }),
    permit_id: PropTypes.string,
    permit_type: PropTypes.string,
    print_count: PropTypes.number,
    reservation_number: PropTypes.string,
    sales_channel_type: PropTypes.number,
    start_date: PropTypes.string,
    status: PropTypes.number,
    type: PropTypes.number,
    updated_on: PropTypes.string,
    user_id: PropTypes.string,
});
